enum AccountDetailsPageSections {
  DEFAULT = "",
  EDIT_ACCOUNT = "#edit-account",
  PAYMENT_METHODS = "#payment-methods",
  NOTIFICATIONS = "#notifications",
  CHANGE_PASSWORD = "#change-password",
  DELETE_ACCOUNT = "#delete-account",
  CREDITS = "#credits",
  GIFT_CARDS = "#gift-cards"
}

export default AccountDetailsPageSections;
